import { useState } from 'react';
import { Add } from '@material-ui/icons';
import { CreateTicketModal } from '../CreateTicket/CreateTicketModal';
import { Button } from '../../../components/Button/NewButton';
import { useUser } from '../../../contexts/UserContext';
import { useOperator } from '../../../contexts/OperatorContext';

interface Props {
  onCreateTicket(): void;
}

export const Header = ({ onCreateTicket }: Props) => {
  const [createTicketOpen, setCreateTicketOpen] = useState(false);
  const operator = useOperator();
  const user = useUser();

  return (
    <div className="block min-w-[300px] w-full">
      <div className="flex items-center justify-between gap-4 w-full p-4">
        <h1 className="text-2xl">Support Tickets</h1>
        {(operator.type === 'Hospitality' &&
          user.permissions.canHosSupportCreate) ||
        (operator.type === 'Residential' &&
          user.permissions.canResSupportCreate) ? (
          <div className="ml-auto shrink-0">
            <Button
              startIcon={<Add fontSize="small" />}
              onClick={() => setCreateTicketOpen(true)}
            >
              New Ticket
            </Button>
          </div>
        ) : null}
      </div>
      <CreateTicketModal
        open={createTicketOpen}
        onClose={() => setCreateTicketOpen(false)}
        onCreateTicket={onCreateTicket}
      />
    </div>
  );
};
